import { render } from "./CreditNoteShopping.vue?vue&type=template&id=88962562"
import script from "./CreditNoteShopping.vue?vue&type=script&lang=js"
export * from "./CreditNoteShopping.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__